"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _ConfirmationModal = _interopRequireDefault(require("../components/ConfirmationModal"));

var _api = require("../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function ConfirmationModal(_ref) {
  var organisationName = _ref.organisationName,
      visible = _ref.visible,
      hideModal = _ref.hideModal,
      assetId = _ref.assetId,
      confirmModalAction = _ref.confirmModalAction,
      onConfirmation = _ref.onConfirmation;
  return _react.default.createElement(_commonReact.RequestProvider, {
    requests: {
      archiveAsset: (0, _api.archiveAssetApi)(),
      unarchiveAsset: (0, _api.unarchiveAssetApi)()
    }
  }, function (_ref2) {
    var archiveAsset = _ref2.archiveAsset,
        unarchiveAsset = _ref2.unarchiveAsset;
    return _react.default.createElement(_ConfirmationModal.default, {
      organisationName: organisationName,
      archiveAsset: archiveAsset,
      unarchiveAsset: unarchiveAsset,
      visible: visible,
      hideModal: hideModal,
      assetId: assetId,
      confirmModalAction: confirmModalAction,
      onConfirmation: onConfirmation
    });
  });
}

var _default = (0, _react.memo)(ConfirmationModal);

exports.default = _default;